function Belarus({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_630)">
        <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#FCFCFC"/>
        <path d="M6.60875 14.8407L4.86963 11.6855L6.60875 8.57983L8.34788 11.6855L6.60875 14.8407Z" fill="#A2001D"/>
        <path d="M3.13048 14.8407L1.39136 11.6855L3.13048 8.57983L4.86961 11.6855L3.13048 14.8407Z" fill="#A2001D"/>
        <path d="M6.60875 23.4203L4.86963 20.2651L6.60875 17.1594L8.34788 20.2651L6.60875 23.4203Z" fill="#A2001D"/>
        <path d="M3.13048 23.4203L1.39136 20.2651L3.13048 17.1594L4.86961 20.2651L3.13048 23.4203Z" fill="#A2001D"/>
        <path d="M8.34786 3.10581L7.85548 2.22656C6.97236 2.74981 6.14405 3.35562 5.38086 4.03337L6.60873 6.26094L8.34786 3.10581Z" fill="#A2001D"/>
        <path d="M6.60867 25.7393L5.3678 27.9553C6.1303 28.6339 6.95805 29.2406 7.8408 29.7649L8.34786 28.845L6.60867 25.7393Z" fill="#A2001D"/>
        <path d="M9.73914 20.1738V30.7278C11.6622 31.5463 13.778 31.9999 16 31.9999C22.8795 31.9999 28.7441 27.6579 31.0048 21.5651L9.73914 20.1738Z" fill="#6DA544"/>
        <path d="M31.0048 21.5652C31.648 19.8319 32 17.9571 32 16C32 7.1635 24.8365 0 16 0C13.7782 0 11.6622 0.453312 9.73914 1.27175V21.5653H31.0048V21.5652Z" fill="#A2001D"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default Belarus;
